module.exports = __webpack_public_path__ + "static/media/sarkarizone6.68ff0e25.jpg";